import axios from 'axios';
import { getAccessToken, LOGIN_URI, REFRESH_TOKEN_URI } from '../services/auth';
import { errorInterceptor } from './interceptors';

const TIMEOUT = 15000;
const EXCLUDED_URI_FOR_AUTH_HEADER = [REFRESH_TOKEN_URI, LOGIN_URI];

const parseUrl = () => {
  const l = window.location;
  return `${l.protocol}//${l.host}`;
};

const api = axios.create({
  baseURL: `${parseUrl()}/api`,
  timeout: TIMEOUT,
});

api.interceptors.request.use((req) => {
  const accessToken = getAccessToken();
  if (!accessToken || EXCLUDED_URI_FOR_AUTH_HEADER.some((uri) => req.url?.endsWith(uri))) {
    return req;
  }
  req.headers = {
    ...req.headers,
    authorization: `Bearer ${accessToken}`,
  };
  return req;
});

api.interceptors.response.use((res) => res, errorInterceptor);

export default api;
